import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const ShippingPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <img
                src="/vetriaAI.png"
                alt="VetriaAI Logo"
                className="w-10 h-10"
              />
              <span className="text-2xl font-bold text-gray-900">VetriaAI</span>
            </div>
            <Link
              to="/"
              className="flex items-center text-gray-600 hover:text-gray-900 font-medium"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <pre className="text-gray-900 font-sans whitespace-pre-line text-base leading-relaxed">
{`Shipping (Digital Delivery)

Last Updated: 09 October 2025

VetriaAI is a cloud-based software. We don\u2019t ship physical goods.

1) Access & Delivery
After purchase or trial activation, admins receive email confirmation and immediate in-app access.
Test generation, assessments, analytics, and badges are delivered digitally within the platform.
Any downloadable reports are accessible via secure links or in-app export.

2) Provisioning Times
Self-serve plans: typically instant after payment confirmation.
Enterprise workspaces: within 1\u20133 business days after contract countersignature and domain verification.

3) Documents & Invoices
Invoices and receipts are sent to the billing email and available in the billing portal.

4) Service Availability
Target 99.9% monthly uptime with 24/7 monitoring and automatic failover.
Planned maintenance is communicated in advance where possible.

5) Failed Delivery
If you don\u2019t receive access within expected timelines, contact info@vetriaai.com
 with your order details.`}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
